import { Injectable } from '@angular/core';
import { IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED, RestService } from 'cargo-chief-commons';
import { Cargochief } from '../cargochief/cargochief.service';
import { CARGOCHIEF_KEYS, PAGE_SIZE } from '@domain/constants/app-variables';
import { UrlService } from '../url/url.service';

@Injectable({
	providedIn: 'root',
})
export class CacheService {
	constructor(
		private cargochief: Cargochief,
		private restService: RestService,
		private urlService: UrlService
	) {}

	updateCache() {
		if (IS_NULL_OR_UNDEFINED(this.cargochief.getItem(CARGOCHIEF_KEYS.USER_CARRIER_MAPS))) {
			this.getUserCarrierMaps();
		}
		if (IS_NULL_OR_UNDEFINED(this.cargochief.getItem(CARGOCHIEF_KEYS.ACCOUNT_USERS))) {
			this.getAccountUsers();
		}

		if (IS_NULL_OR_UNDEFINED(this.cargochief.getItem(CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS))) {
			this.getNotificationSettings();
		}

		if (IS_NULL_OR_UNDEFINED(this.cargochief.getItem(CARGOCHIEF_KEYS.INTEGRATION_TYPES))) {
			this.getIntegrationTypes();
		}
	}

	getUserCarrierMaps() {
		const url = this.urlService.userCarrierMap();
		this.restService.GET(url).subscribe((response) => {
			this.cargochief.setItem({ [CARGOCHIEF_KEYS.USER_CARRIER_MAPS]: response.data });
		});
	}

	getAccountUsers() {
		const accountId = this.cargochief.ACCOUNT_ID;
		if (IS_NOT_NULL_OR_UNDEFINED(accountId)) {
			const url = this.urlService.getAllAccountUsers(accountId, 0, PAGE_SIZE.USERS_LIST_CACHE);
			this.restService.GET(url).subscribe((response) => {
				this.cargochief.setItem({ [CARGOCHIEF_KEYS.ACCOUNT_USERS]: response.data });
			});
		}
	}

	getNotificationSettings() {
		const url = this.urlService.notificationSettings();
		this.restService.GET(url).subscribe((response) => {
			this.cargochief.setItem({ [CARGOCHIEF_KEYS.NOTIFICATION_SETTINGS]: response.data });
		});
	}

	getIntegrationTypes() {
		const url = this.urlService.integrationTypesUrl();
		this.restService.GET(url).subscribe((response) => {
			this.cargochief.setItem({ [CARGOCHIEF_KEYS.INTEGRATION_TYPES]: response.data });
		});
	}
}
